export const Iconstyles = {
    state: {
        iconstyles: {
            1: { id: 1, pos: 1 },
            2: { id: 2, pos: 2 },
            3: { id: 3, pos: 3 },
            4: { id: 4, pos: 4 },
            5: { id: 5, pos: 5 },
            6: { id: 6, pos: 6 }
        }
    },
    mutations: {},
    getters: {
        getIconstyles(state) {
            return state.iconstyles;
        },
        getIconstyleDefault(state) {
            let items = Object.keys(state.iconstyles);
            return items[Math.floor(Math.random() * items.length)];
        },
        getActiveIconstyle(state, getters) {
            return getters.getProp('tecpage.user.settings.iconstyle');
        }
    }
};
